import { put, race, take } from 'redux-saga/effects';
import {
  actionTypes,
  getParticipation,
} from 'modules/Profile/redux/participationInQesOrganization/actions';

import {
  actionTypes as statusActionTypes,
  startRequest,
} from 'modules/Profile/redux/personalStatus/actions';
import { initializeQSAFailure, initializeQSASuccess } from '../redux/actions';

export function* initQSASaga() {
  yield put(getParticipation());
  yield put(startRequest());

  const { success, failure } = yield race({
    success: take([actionTypes.REQUEST_SUCCESS, statusActionTypes.REQUEST_SUCCESS]),
    failure: take([actionTypes.REQUEST_FAILURE, statusActionTypes.REQUEST_FAILURE]),
  });

  if (success) {
    yield put(initializeQSASuccess());
  }

  if (failure) {
    yield put(initializeQSAFailure());
  }
}
